import React from "react";
import { ReactComponent as TickIcon } from "assets/img/svg/TickIcon.svg"; // same icon used in system
import AButton from "views/pages/manage/common/form-fields-mui/AButton";

const tickStyle = {
  background: "#05945B",
  borderRadius: "50%",
  height: "30px",
  width: "30px",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
};

const ChequeCancelledSuccess = ({
  details = {},
  onClose = () => {}, // Go to dashboard / close modal
  onView = () => {}, // View deposit slip
}) => {
  const { receiptIds = "--" } = details;

  return (
    <div style={{ minWidth: "400px" }}>
      {/* Header */}
      <div className="d-flex align-items-center gap-3 mb-4">
        <div style={tickStyle}>
          <TickIcon />
        </div>
      </div>

      <div className="mb-4 d-flex  justify-content-between">
        <div className="regular-bold color-black mb-1">
          Negative receipt generated. Receipt No : {" "}
        </div>
        <div className="label-color regular-text semi-bold  text-dark">
          {receiptIds.join(", ")}
        </div>
      </div>

      <div className="d-flex gap-3">
      </div>
    </div>
  );
};

export default ChequeCancelledSuccess;
